import { render, staticRenderFns } from "./trademarkDetails.vue?vue&type=template&id=dac9cf58&scoped=true&"
import script from "./trademarkDetails.vue?vue&type=script&lang=js&"
export * from "./trademarkDetails.vue?vue&type=script&lang=js&"
import style0 from "./trademarkDetails.vue?vue&type=style&index=0&id=dac9cf58&prod&scoped=true&lang=scss&"
import style1 from "./trademarkDetails.vue?vue&type=style&index=1&id=dac9cf58&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dac9cf58",
  null
  
)

export default component.exports